import { render, staticRenderFns } from "./EduRecords.vue?vue&type=template&id=33e66988&scoped=true"
import script from "./EduRecords.vue?vue&type=script&lang=js"
export * from "./EduRecords.vue?vue&type=script&lang=js"
import style0 from "./EduRecords.vue?vue&type=style&index=0&id=33e66988&prod&scoped=true&lang=css"
import style1 from "./EduRecords.vue?vue&type=style&index=1&id=33e66988&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e66988",
  null
  
)

export default component.exports